import { useEffect, useState } from "react";
import {
  BsExclamationTriangle,
  FiAlertOctagon,
  FiInfo,
} from "../../assets/icons/vander";
import { useSecretaryStore } from "../../hooks";
import { formatToDMYHM } from "../../helpers";
import {
  TableEvaluationPatient,
  ResultEvaluationPatient,
  ResultValorationPatient,
  TableEvaluationEndingPatient,
  MedicalExams,
} from "./";

export const HistoryPatientSurgery = ({ patientId }) => {
  // Datos del hook ----------------------------------------//
  const { startGetPatientSurgeries, checking } = useSecretaryStore();

  // States ------------------------------------------------//
  const [patientSurgeries, setPatientSurgeries] = useState([]);
  const [errorMessage, setErrorMessage] = useState(undefined);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const getPatientSurgeries = async (patientId) => {
    const response = await startGetPatientSurgeries(patientId);
    if (typeof response === "string") {
      return setErrorMessage(response);
    }
    if (Array.isArray(response)) {
      return setPatientSurgeries(response);
    }
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    getPatientSurgeries(patientId);
  }, [patientId]);

  // useEffect(() => {
  //   console.log(patientSurgeries);
  // }, [patientSurgeries]);

  return (
    <>
      {patientSurgeries.length > 0 && (
        <div className="accordion" id="patientSurgeries">
          {patientSurgeries.map((patientSurgery) => (
            <div
              className="accordion-item"
              key={`patient-surgery-${patientSurgery.id}`}
            >
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#patient-surgery-${patientSurgery.id}`}
                  aria-expanded="false"
                  aria-controls={`patient-surgery-${patientSurgery.id}`}
                >
                  Procedimiento:{" "}
                  {patientSurgery.procedure?.procedureParentName
                    ? `${patientSurgery.procedure.procedureParentName}`
                    : patientSurgery.procedure.title}{" "}
                  {patientSurgery.createdAt}
                </button>
              </h2>
              <div
                id={`patient-surgery-${patientSurgery.id}`}
                className="accordion-collapse collapse"
                data-bs-parent="#patientSurgeries"
              >
                <div className="accordion-body">
                  <div className="accordion" id="subPatientSurgeries">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#procedure-${patientSurgery.procedure.id}`}
                          aria-expanded="true"
                          aria-controls={`procedure-${patientSurgery.procedure.id}`}
                        >
                          Resultados
                        </button>
                      </h2>
                      <div
                        id={`procedure-${patientSurgery.procedure.id}`}
                        className="accordion-collapse collapse show"
                        data-bs-parent="#subPatientSurgeries"
                      >
                        <div className="accordion-body">
                          <ResultEvaluationPatient {...patientSurgery} />
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#assessment-${patientSurgery.procedure.assessment.id}`}
                          aria-expanded="true"
                          aria-controls={`assessment-${patientSurgery.procedure.assessment.id}`}
                        >
                          Evaluación:{" "}
                          {patientSurgery.procedure.assessment.title}
                        </button>
                      </h2>
                      <div
                        id={`assessment-${patientSurgery.procedure.assessment.id}`}
                        className="accordion-collapse collapse"
                        data-bs-parent="#subPatientSurgeries"
                      >
                        <div className="accordion-body">
                          {patientSurgery.evaluations?.EVALUATION?.length >
                          0 ? (
                            <TableEvaluationPatient
                              evaluations={
                                patientSurgery.evaluations.EVALUATION
                              }
                            />
                          ) : (
                            <div
                              className="alert bg-soft-yellow fw-medium"
                              role="alert"
                            >
                              <FiInfo className="fs-5 align-middle me-1" /> El
                              paciente no ha respondido a la encuesta
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#events${patientSurgery.id}`}
                          aria-expanded="true"
                          aria-controls={`events${patientSurgery.id}`}
                        >
                          Exámenes medicos
                        </button>
                      </h2>
                      <div
                        id={`events${patientSurgery.id}`}
                        className="accordion-collapse collapse"
                        data-bs-parent="#subPatientSurgeries"
                      >
                        <div className="accordion-body">
                          <MedicalExams
                            scheduleEvents={patientSurgery.assessmentEvents}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#gosafeValoration${patientSurgery.id}`}
                          aria-expanded="true"
                          aria-controls={`gosafeValoration${patientSurgery.id}`}
                        >
                          Valoración
                        </button>
                      </h2>
                      <div
                        id={`gosafeValoration${patientSurgery.id}`}
                        className="accordion-collapse collapse"
                        data-bs-parent="#subPatientSurgeries"
                      >
                        <div className="accordion-body">
                          <ResultValorationPatient {...patientSurgery} />
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#gosafeevaluationEnding${patientSurgery.id}`}
                          aria-expanded="true"
                          aria-controls={`gosafeevaluationEnding${patientSurgery.id}`}
                        >
                          Encuesta de satisfacción
                        </button>
                      </h2>
                      <div
                        id={`gosafeevaluationEnding${patientSurgery.id}`}
                        className="accordion-collapse collapse"
                        data-bs-parent="#subPatientSurgeries"
                      >
                        <div className="accordion-body">
                          {patientSurgery.evaluations?.ENDING?.length > 0 ? (
                            <TableEvaluationEndingPatient
                              evaluations={patientSurgery.evaluations.ENDING}
                            />
                          ) : (
                            <div
                              className="alert bg-soft-yellow fw-medium"
                              role="alert"
                            >
                              <FiInfo className="fs-5 align-middle me-1" /> El
                              paciente no ha respondido a la encuesta de
                              satisfacción
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Mensajes */}
      <>
        {checking && (
          <div className="alert bg-soft-warning fw-medium" role="alert">
            <BsExclamationTriangle className="fs-5 align-middle me-1" />{" "}
            Cargando...
          </div>
        )}
        {errorMessage && (
          <div className="alert bg-soft-danger fw-medium" role="alert">
            <FiAlertOctagon className="fs-5 align-middle me-1" /> {errorMessage}
          </div>
        )}
      </>
    </>
  );
};
